import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";
import type { FilterItemType } from "@shared/content-types/types";

import {
  type EquipmentsPageType,
  mapDtoToEquipmentPage,
  mapDtoToEquipmentPoints,
  mapDtoToEquipmentTypes,
} from "../model";
import type { EquipmentPoints } from "../model/types";
import { searchParams } from "./params";

type DataType = {
  pageData: EquipmentsPageType;
  list: EquipmentPoints;
  filters: FilterItemType[];
};

export const getEquipmentsPage = async () => {
  const equipmentsPage = strapiClient.single("equipments-page");
  const equipmentsPoints = strapiClient.collection("equipments-points");
  const equipmentsTypes = strapiClient.collection("equipments-types");

  const page = await equipmentsPage.find({
    ...searchParams.page,
  });

  const points = await equipmentsPoints.find({
    ...searchParams.points,
  });

  const types = await equipmentsTypes.find();

  return rebuild({
    pageData: mapDtoToEquipmentPage(page),
    list: mapDtoToEquipmentPoints(points),
    filters: mapDtoToEquipmentTypes(types),
  }) as DataType;
};
